import React, { useRef, useState, useEffect } from 'react';
import styled from "styled-components";

import Loading from "./Loading";
import Content from "./Content";

import "../styles/reset.scss";
import "../styles/common.scss";


const App = () => {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
  
      setTimeout(() => {
        setLoading(!loading)
        // console.log('いいいいい');
      }, 3000);

  }, []);

  // const showContent = () => {
  //   setTimeout(() => {
  //     return (
  //       <>
  //         <Content />
  //       </>
  //     )
  //   }, 1000);
  // }
  

  return(
    <>
      {loading 
      ? (<Content />)
      : (<Loading />) 
      }
    </>
  )
}

export default App
